import { SCHEMES } from '@webapp/common/components/charts/utils';
import { DisallowRefillingTimeType, DisallowRefillingType, IndicatorPosition } from '@webapp/common/resources/survey';

export type TChartColorScheme = { id: string; colors: Array<string> };
export type TChartColorSchemes = Array<TChartColorScheme>;

export interface SurveyAddonParams {
    backToQuestion: boolean;
    chartColorSchemes?: TChartColorSchemes;
    clickReply: boolean;
    audioRecogn: boolean;
    copyUrlParams: boolean;
    disallowRefilling: boolean;
    disallowRefillingCount: number;
    disallowRefillingTime: number;
    disallowRefillingTimeType: DisallowRefillingTimeType;
    disallowRefillingType: DisallowRefillingType;
    disallowTextCopy: boolean;
    indicator: boolean;
    indicatorPosition: IndicatorPosition;
    ipLimiter: boolean;
    showQuestionNumber: boolean;
    showRequiredToQuestion: boolean;
}

export const initialSurveyAddonParams: Readonly<SurveyAddonParams> = {
    showRequiredToQuestion: true,
    showQuestionNumber: true,
    backToQuestion: false,
    indicator: false,
    indicatorPosition: IndicatorPosition.BOTTOM,
    clickReply: true,
    audioRecogn: false,
    ipLimiter: false,
    disallowRefilling: false,
    disallowTextCopy: false,
    copyUrlParams: false,
    disallowRefillingType: DisallowRefillingType.ALL_TIME,
    disallowRefillingCount: 1,
    disallowRefillingTime: 1,
    disallowRefillingTimeType: DisallowRefillingTimeType.HOUR,
    chartColorSchemes: SCHEMES,
};
